import { render } from "./EditPlantJournalPositions.vue?vue&type=template&id=0b49f4e5"
import script from "./EditPlantJournalPositions.vue?vue&type=script&lang=js"
export * from "./EditPlantJournalPositions.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__